import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const FIGHT_IMG = 'https://wver.sprintstaticdata.com/v230/static/admin/img/fight.png';

function findByNat(sub, nat) {
  return sub.find((s) => s.nat === nat);
}
function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}
function fmtAmt(n) {
  const v = Number(n) || 0;
  if (v >= 100000) return `${v / 100000}L`;
  if (v >= 1000) return `${v / 1000}K`;
  return String(v);
}

// 1 Card Meter (cmeter1) — table one-card-meter. Do fighter buttons (A/B).
// Har meter-btn: min-max (Min/Max) + meter-btn-box (button, suspended jab susp) +
// book-green wrapper me book-black b (hamesha). fight img admin CDN se.
const BetTableMeter = memo(function BetTableMeter({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});
  const fighterA = findByNat(sub, 'Fighter A');
  const fighterB = findByNat(sub, 'Fighter B');
  const bookA = bookOf(exposures, 'Fighter A');
  const bookB = bookOf(exposures, 'Fighter B');

  return (
    <div className="meter-btns">
      <div className="meter-btn">
        <div className="text-right min-max">
          {'\n                  Min:'}<span>{fmtAmt(fighterA?.min ?? 50)}</span>
          {'\n                  Max:'}<span>{fmtAmt(fighterA?.max ?? 100000)}</span>
        </div>
        {' '}
        <div className={`meter-btn-box${suspCls(fighterA)}`}>
          <button
            className={`btn btn-fighter-1${suspCls(fighterA)}`}
            onClick={isSusp(fighterA) ? undefined : () => handleBet(fighterA.sid, 'back', fighterA.b || 0, fighterA)}
          >
            {'\n                    Fighter A\n                    '}
            <img src={FIGHT_IMG} alt="Fight" />
          </button>
        </div>
        {' '}
        <div className="book-green text-center"><b className={bookCls(bookA)}>{fmtBook(bookA)}</b></div>
      </div>
      {' '}
      <div className="meter-btn">
        <div className="text-right min-max">
          {'\n                  Min:'}<span>{fmtAmt(fighterB?.min ?? 50)}</span>
          {'\n                  Max:'}<span>{fmtAmt(fighterB?.max ?? 100000)}</span>
        </div>
        {' '}
        <div className={`meter-btn-box${suspCls(fighterB)}`}>
          <button
            className={`btn btn-fighter-2${suspCls(fighterB)}`}
            onClick={isSusp(fighterB) ? undefined : () => handleBet(fighterB.sid, 'back', fighterB.b || 0, fighterB)}
          >
            <img src={FIGHT_IMG} alt="Fight" />
            {'\n                    Fighter B\n                  '}
          </button>
        </div>
        {' '}
        <div className="book-green text-center"><b className={bookCls(bookB)}>{fmtBook(bookB)}</b></div>
      </div>
    </div>
  );
});

export default BetTableMeter;
